<template>
     <div class="fh_container">
         <div class="fh_header">
            <img src="@/assets/img/login/logo.jpg" alt="logo" class="header_logo">
        </div>
        <div class="content_main">
            <div style="min-height: 390px; background: #FFFFFF">
                <p class="steps_title">{{$t('cfgGuide.title')}}</p>
                <!-- 步骤导航 -->
                <div class="steps" >
                    <div class="step" v-for="(step, index) in steps" :key="index">
                        <div class="step_head">
                            <div class="step_icon "  v-bind:class="{ step_icon_is_success: step.isAction}">
                                <div class="step_icon_inner"  v-if="(index !== (steps.length - 1))">
                                    {{index + 1}}
                                </div>
                                <div class="step_icon_inner" v-else>
                                    <i class="is_checked"></i>
                                </div>
                            </div>
                            <div class="step_line" v-show="(index !== (steps.length - 1))">
                                <i class="step_line_inner"></i>
                            </div>
                        </div>
                        <div class="step_main">
                            <div class="step_title" v-bind:class="{ step_title_is_success: step.isAction}">
                                {{step.text}}
                            </div>
                        </div>
                    </div>
                </div>
                <!-- 步骤内容 -->
                <div class="step_center">
                    <!-- 修改用户名密码 -->
                    <div v-if="stepStatus === 'account_setting'" class="step-form">
                        <p class="step_form_title">{{$t('cfgGuide.accout.title')}}</p>
                        <el-form 
                            :rules="formCheck.account" 
                            :model="account"
                            ref="accountForm"
                            :label-position="'left'" 
                            label-width="100px">
                            <el-form-item :label="$t('cfgGuide.accout.name')" prop="name">
                                <el-input v-model="account.name"  :disabled="account.isNameDisable">
                                    <el-button @click="account.isNameDisable = !account.isNameDisable" icon="el-icon-edit" slot="append"></el-button>
                                </el-input>
                            </el-form-item>
                            <el-form-item :label="$t('cfgGuide.accout.password')" prop="password">
                                <el-input v-model="account.password" show-password></el-input>
                            </el-form-item>
                            <el-form-item class="step-form-btn">
                                <div class="step_center_btn" @click="sendAccount()">{{$t('cfgGuide.next')}}</div>
                            </el-form-item>
                        </el-form>
                    </div>
                    <!-- 获取网线连接状态 -->
                    <div v-if="stepStatus === 'lan_status_get'">
                        <div class="step_center_img">
                            <img src="@/assets/img/configGuide/ic_router.png">
                            <div class="ball-pulse">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <img src="@/assets/img/configGuide/ic_internet.png"> 
                        </div>
                        <div class="step_center_des">
                            {{$t('cfgGuide.netStatus')}}
                        </div>
                    </div>
                    <!-- 网线未连接 -->
                    <div v-if="stepStatus === 'lan_status_error'">
                        <div class="step_center_img">
                            <img src="@/assets/img/configGuide/pic_no_network.png">
                        </div>
                        <div class="step_center_des">
                            <h2>{{$t('cfgGuide.netError')}} <img src="@/assets/img/configGuide/ic_help.png" @click="isShowHelp = true"></h2>
                            <p class="no_lan_des">{{$t('cfgGuide.netErrorDec')}}</p>
                        </div>
                        <div class="step_btn">
                            <div class="step_center_btn" v-on:click="againLan">{{$t('cfgGuide.againLan')}}</div>
                        </div>
                        <div class="step-form-btn" style="margin-top: 30px;">
                            <el-link :underline="false" @click="login">{{$t('cfgGuide.goOutGuide')}}</el-link>
                        </div>

                    </div>
                    <!-- 检查wifi状态 -->
                    <div v-if="stepStatus === 'wifi_status_get'">
                        <div class="step_center_img">
                            <img src="@/assets/img/configGuide/ic_router.png">
                            <div class="ball-pulse">
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <img src="@/assets/img/configGuide/ic_internet.png"> 
                        </div>
                        <div class="step_center_des">
                            {{$t('cfgGuide.wlanStatus')}}
                        </div>
                    </div>
                    <!-- wifi未开启 -->
                    <div v-if="stepStatus === 'wifi_status_error'">
                        <div class="step_center_img">
                            <img src="@/assets/img/configGuide/pic_no_contact.png">
                        </div>
                        <div class="step_center_des">
                            <h2>{{$t('cfgGuide.wlanError')}} <img src="@/assets/img/configGuide/ic_help.png"></h2>
                            <p class="no_lan_des">{{$t('cfgGuide.wlanErrorDec')}}</p>
                        </div>
                        <div class="step_btn">
                            <div class="step_center_btn" v-on:click="login">{{$t('cfgGuide.goLogin')}}</div>
                        </div>
                    </div>
                    <!-- Wi-Fi 配置 -->
                    <div v-if="stepStatus === 'wlan_setting'" class="step-form">
                        <p class="step_form_title">{{$t('cfgGuide.wlan.title')}}</p>
                        <el-form 
                            :rules="formCheck.wlan" 
                            :model="wlan"
                            ref="wlanForm"
                            :label-position="'left'" 
                            label-width="100px">
                            <el-form-item label="SSID" prop="ssid">
                                <el-input v-model="wlan.ssid"></el-input>
                            </el-form-item>
                            <el-form-item :label="$t('cfgGuide.wlan.password')" prop="password">
                                <el-input v-model="wlan.password" show-password></el-input>
                            </el-form-item>
                            <el-form-item v-if="wlan.ssid != ''">
                                <span style="color:#F56C6C">{{$t('cfgGuide.wlan.dec',{ssid:wlan.ssid})}}</span>
                            </el-form-item>
                            <el-form-item class="step-form-btn">
                                <div class="step_center_btn" @click="sendWlan()">{{$t('cfgGuide.next')}}</div>
                            </el-form-item>
                            <el-form-item class="step-form-btn">
                                <el-link :underline="false" @click="login">{{$t('cfgGuide.goOutGuide')}}</el-link>
                            </el-form-item>
                        </el-form>

                    </div>
                    <!-- 连接成功 -->
                    <div v-if="stepStatus === 'link_success'">
                        <div class="step_center_img">
                            <img src="@/assets/img/configGuide/pic_contact.png">
                        </div>
                        <div class="step_center_des">
                            <h2>{{$t('cfgGuide.setSuccess')}}</h2>
                            <p class="no_lan_des">{{$t('cfgGuide.setSuccessDec')}}</p>
                        </div>
                        <div class="step_btn">
                            <div class="step_center_btn" v-on:click="againEnd">{{$t('cfgGuide.againSet')}}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <fhFooter/>
        <!-- 帮助信息弹出层 -->
        <el-dialog  :visible.sync="isShowHelp" width="500px" :title="$t('cfgGuide.help.title')">
            <p>{{$t('cfgGuide.help.dec1')}}</p>
            <p>{{$t('cfgGuide.help.dec2')}}</p>
            <p>{{$t('cfgGuide.help.dec3')}}</p>
        </el-dialog>
     </div>
     
</template>

<script>
import fhFooter from '@/components/footer'
import sizeof from '@/util/jsCharLength.js'
export default {
    components:{
        fhFooter
    },
    data(){
        return {
            endTimeoutid:0, // 返回首页超时调用ID
            isShowHelp:false,
            stepStatus: "account_setting",
            stepNumm : 0,
            account:{
                isNameDisable:true,
                name:"",
                password:""
            },
            wlan:{
                ssid:"",
                password:""
            },
            formCheck:{
                account:{
                    name:[
                        { required: true, message: this.$t('cfgGuide.check.accout.nameEpt'), trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 30 || sizeof(value,'utf-8') < 1)
                                    callback(new Error(this.$t('cfgGuide.check.accout.nameErr')))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
                    password:[
                        { required: true, message: this.$t('cfgGuide.check.accout.passwordEpt'), trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                let reg = /^(?=.*\d)(?=.*[a-zA-Z])(?=.*[ !"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[\s\S]{8,30}$/;
                                if (!reg.test(value)) {
                                callback(
                                        new Error(this.$t('cfgGuide.check.accout.passwordErr'))
                                    )
                                } else {
                                    callback()
                                }
                            },
                            trigger: 'blur' 
                        }
                    ]
                },
                wlan:{
                    ssid:[
                        { required: true, message: this.$t('cfgGuide.check.wlan.ssidEpt'), trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 30 || sizeof(value,'utf-8') < 1)
                                    callback(new Error(this.$t('cfgGuide.check.wlan.ssidErr')))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
                    password:[
                        { required: true, message: this.$t('cfgGuide.check.wlan.passwordEpt'), trigger: 'blur' },
                        { 
                            validator:(rule, value, callback) => {
                                if(sizeof(value,'utf-8') > 64 || sizeof(value,'utf-8') < 8)
                                    callback(new Error(this.$t('cfgGuide.check.wlan.passwordErr')))
                                else
                                    callback()
                            },
                            trigger: 'blur' 
                        }
                    ],
                }
            },
            steps: [
                {
                    text:this.$t('cfgGuide.steps.accoutTitle') , 
                    isAction : true,
                    method(that){
                        axios
                        .post("/JSONAPI",{
                            cmdType:"SET_GUIDE_PASSWORD",
                            userName:that.account.name,
                            password:that.account.password
                        })
                        .then((response)=>{
                            if(response.data.ret !== 0)
                                that.$message.error(that.$t('cfgGuide.steps.accoutErr'))
                            else
                            {
                                that.$GCONFIG.isShowGuide = false
                                that.stepNext()
                            }
                               
                        })
                        .catch((error) => {
                            that.$message.error(that.$t('cfgGuide.steps.accoutErr'))
                        })
                    }
                },
                {
                    text:this.$t('cfgGuide.steps.netTitle') , 
                    isAction : false,
                    method(that){
                        that.stepStatus = "lan_status_get"
                        setTimeout(function () {
                            axios.post('/boafrm/fhQuickSteps',{CmdType:"GET_LAN_STATUS"})
                            .then(function (response) {
                                if(response.data.lanSatus)
                                {
                                    that.stepNext();
                                }
                                else
                                {
                                    that.stepStatus = "lan_status_error";
                                }
                            })
                            .catch(function (error) {
                                that.stepStatus = "lan_status_error";
                            });
                        },3000)
                        
                    }
                },
                {
                    text:this.$t('cfgGuide.steps.wlan') , 
                    isAction : false,
                    method(that){
                        that.stepStatus = "wifi_status_get"
                        setTimeout(function () {
                            axios.post('/boafrm/fhQuickSteps',{CmdType:"GET_WLAN_SWITCH"})
                            .then(function (response) {
                                if(response.data.wlSwitch)
                                {
                                    that.stepStatus = 'wlan_setting'
                                }
                                else
                                {
                                    that.stepStatus = "wifi_status_error";
                                }
                            })
                            .catch(function (error) {
                                that.stepStatus = "wifi_status_error";
                            });
                        },3000)
                    }
                },
                {
                    text:this.$t('cfgGuide.steps.setEnd')  , 
                    isAction : false,
                    method(that){
                        that.stepStatus = "link_success"
                        that.endTimeoutid = setTimeout(function () {
                            that.login()
                        },5000)
                    }
                },
            ]
        }
    },
    created(){
        axios
        .post("/boafrm/loginpassword", {CmdType: "GET_PASSWORD"})
        .then((response) => {
            this.account.name = response.data.userName || 'user'
        })
    },
    methods:{
        againLan(){
            this.stepStatus = "lan_status_get";
            this.steps[this.stepNumm].method(this);
        },
        stepNext(){
            this.stepNumm++;
            if(this.stepNumm >= this.steps.length)
            {
                console.log("已经到最后一步");
                return;
            }
            this.steps[this.stepNumm].method(this);
            this.steps[this.stepNumm].isAction = true;
    
        },
        againEnd(){
            if(this.endTimeoutid !=0)
                clearTimeout(this.endTimeoutid);
            this.steps.forEach(e => {
                e.isAction = false
            })
            this.steps[0].isAction = true
            this.stepStatus = 'account_setting'
            this.stepNumm = 0
        },
        login(){
            this.$router.push('login')
        },
        sendAccount(){
            this.$refs['accountForm'].validate((valid) => {
                if(valid)
                    this.steps[this.stepNumm].method(this);
                else
                    return false;
            })
        },
        sendWlan(){
            this.$refs['wlanForm'].validate((valid) => {
                if(valid)
                {
                    axios
                    .post("/JSONAPI",{
                        cmdType:"SET_GUIDE_WLAN",
                        ssid:this.wlan.ssid,
                        password:this.wlan.password
                    })
                    .then((response)=>{
                        if(response.data.ret !== 0)
                            this.$message.error(this.$t('cfgGuide.steps.setWanFiald') )
                        else
                            this.stepNext()
                    })
                    .catch((error) => {
                        this.$message.error(this.$t('cfgGuide.steps.setWanFiald'))
                    })
                }
                else
                {
                    return false;
                }
                
            })
        }
    }
}

</script>

<style src="@/assets/style/configGuide.scss" lang="scss"></style>







